import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import alasql from "alasql";
import XLSX from 'xlsx';
import Papa from 'papaparse';

alasql.utils.isBrowserify = false;
alasql.utils.global.XLSX = XLSX;

export const downloadCSV = (csv, filename = 'report') => {
  let hiddenElement = document.createElement('a');
  document.body.appendChild(hiddenElement);
  let csvData = new Blob([csv], { type: 'text/csv' });
  hiddenElement.href = URL.createObjectURL(csvData);
  hiddenElement.target = '_blank';
  hiddenElement.download = `${filename}.csv`;
  hiddenElement.click();
}

function getImageUri(url) {
  return new Promise((resolve) => {
    let image = new Image();
    image.setAttribute('crossOrigin', 'anonymous');

    image.onload = function () {
      let canvas = document.createElement('canvas');
      canvas.width = this.naturalWidth;
      canvas.height = this.naturalHeight;

      //next three lines for white background in case png has a transparent background
      let ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff';  /// set white fill style
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      canvas.getContext('2d').drawImage(this, 0, 0);
      resolve(canvas.toDataURL('image/jpeg'));
    };
    image.src = url;
  })
}

export const downloadPDF = async (csv, info = {}, filename = 'report') => {
  const { orientation, report_name, date_from, date_to, chart, station, title1, title2, logo, images, columnStyles, noHeader } = info;
  let doc = new jsPDF({
    format: 'a4',
    orientation: orientation || "portrait",
  });

  let lines = csv.split('\n');
  let header = noHeader ? null : lines.splice(0, 1);


  let parsedCsv = Papa.parse(csv, {
    header: false,
    skipEmptyLines:false,
    dynamicTyping: true
  });

  lines = parsedCsv.data;
  let subTitle = report_name + (!!date_from && !!date_to ? ` Data From ${date_from} to ${date_to}` : '');
  // change background to white
  let reportLogo;
  if (logo) reportLogo = await getImageUri(logo || '/bwdb-logo.png');
  const pageWidth = doc.internal.pageSize.getWidth();
  if (!!chart) {
    const getMetadata = (metadata, name) => {
      if (!metadata) return ''
      let md = metadata.find(item => item.name === name);
      if (!md) return '';
      return md.value;
    }
    doc.autoTable({
      head: !!station ? [['Property', 'Value', 'Property', 'Value']] : [],
      body: !!station ? [
        ['Station ID', station.identifier, 'Station Name', station.name],
        ['District', getMetadata(station.meta_data, 'District'), 'Upazila', getMetadata(station.meta_data, 'Upazila')],
        ['Latitude, Longitude', `${station.latitude}, ${station.longitude}`, 'Address Detail', station.location],
        ['Installation Date', getMetadata(station.meta_data, 'Installation Date')],
      ] : [],
      theme: 'plain',
      margin: { top: 40 },
      styles: {
        fontSize: 8,
        lineColor: '#777',
        lineWidth: 0.05
      },
      headStyles: {
        halign: 'center',
      },
      showHead: "everyPage",
      didDrawPage: () => {
        if (reportLogo) doc.addImage(reportLogo, 'PNG', 15, 8, 15, 15);
        doc.setFontSize(12)
        doc.text(title1, (pageWidth - doc.getTextWidth(title1)) / 2, 12);
        doc.text(title2, (pageWidth - doc.getTextWidth(title2)) / 2, 18);
        doc.setFontSize(8)
        doc.text(subTitle, (pageWidth - doc.getTextWidth(subTitle)) / 2, 24);
        doc.line(15, 31, pageWidth - 15, 30);
        doc.setFontSize(8)
        doc.text('Report No.:', 12, 36)
        doc.text('Date:', pageWidth - 40, 36)
        doc.addImage(chart, 'svg', 10, !!station ? 80 : 50);
        doc.text('Prepared By:', 12, doc.internal.pageSize.getHeight() - 10)
        doc.text('Approved By:', pageWidth - 44, doc.internal.pageSize.getHeight() - 10)
      }
    });
    doc.addPage();
  }

  const content = Object.assign(
    {},
    {
      theme: 'plain',
      margin: { top: 40 },
      styles: {
        fontSize: 8,
        lineColor: '#777',
        lineWidth: 0.05
      },
      headStyles: {
        halign: 'center',
      },
      showHead: "everyPage",
      body: lines.slice(1, lines.length),
      didDrawPage: () => {
        if (reportLogo) doc.addImage(reportLogo, 'PNG', 15, 8, 15, 15);
        doc.setFontSize(12)
        doc.text(title1, (pageWidth - doc.getTextWidth(title1)) / 2, 12);
        doc.text(title2, (pageWidth - doc.getTextWidth(title2)) / 2, 18);
        doc.setFontSize(8)
        doc.text(subTitle, (pageWidth - doc.getTextWidth(subTitle)) / 2, 24);
        doc.line(15, 31, pageWidth - 15, 30);
        doc.setFontSize(8)
        doc.text('Report No.:', 12, 36)
        doc.text('Date:', pageWidth - 40, 36)
        doc.text('Prepared By:', 12, doc.internal.pageSize.getHeight() - 10)
        doc.text('Approved By:', pageWidth - 44, doc.internal.pageSize.getHeight() - 10)
      }
    },
    !!header ? { head: header.map(item => item.split(',')) } : {},
    !!columnStyles ? { columnStyles: { '0': columnStyles } } : {},
  );
  doc.autoTable(content);

  if (!!images) {
    doc.autoTable({
      body: [images.map(() => '')],
      theme: 'plain',
      margin: { top: 40 },
      didDrawCell: (data) => {
        if ((data.row.section === 'body')) {
          if (images[data.column.index]) doc.addImage(images[data.column.index], 'JPG', data.cell.x, data.cell.y, 50, 50)
        }
      },
    });
  }
  doc.save(`${!!station ? station.name : filename}.pdf`);
  return Promise.resolve();
}

export const downloadXlsx = async (csv, filename = 'report') => {
  const sheets = [{ sheetid: 'Stations' }]
  const dataArray = [];

  csv = csv.split('\n');

  const header = csv.shift().split(',');

  csv.forEach(line => {
    let obj = {};
    line.split(',').forEach((item, index) => {
      obj[header[index]] = item;
    });
    dataArray.push(obj);
  });

  alasql.promise(`SELECT * INTO XLSX("${filename}.xlsx", ?) FROM ?`, [sheets, [dataArray]]);
}


// WEBPACK FOOTER //
// ./src/components/DataDelivery/ReportingTemplate/downloader.js